@file:Suppress("TooGenericExceptionCaught")
package com.klantenstop.web.pages.admin.categories

import com.klantenstop.web.data.repos.CategoryRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class CategoriesViewModel(
    private val categoryRepo: CategoryRepo = CategoryRepo
) : ViewModel(), CategoriesContract {

    private val _state = MutableStateFlow(CategoriesContract.State())
    override val state: StateFlow<CategoriesContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<CategoriesContract.Effect>()
    override val effect: SharedFlow<CategoriesContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(CategoriesContract.Intent.LoadCategories)
    }

    override fun sendIntent(intent: CategoriesContract.Intent) = coroutineScope.launch {
        when (intent) {
            is CategoriesContract.Intent.NavigateToManage -> emitEffect(CategoriesContract.Effect.NavigateToManage(intent.categoryId))
            is CategoriesContract.Intent.LoadCategories -> loadCategories()
            is CategoriesContract.Intent.SearchCategories -> searchCategories(intent.query)
            is CategoriesContract.Intent.DeleteCategory -> deleteCategory(intent.categoryId)
            is CategoriesContract.Intent.SetCategoryToDelete -> updateState { it.copy(categoryToDelete = intent.category) }
        }
    }

    override fun emitEffect(effect: CategoriesContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (CategoriesContract.State) -> CategoriesContract.State) {
        _state.update(block)
    }

    private suspend fun loadCategories() {
        updateState { it.copy(isLoading = true) }

        val categories = categoryRepo.getCategories()

        updateState {
            it.copy(
                categories = categories,
                isLoading = false
            )
        }
    }

    private fun searchCategories(query: String) {
        updateState { it.copy(searchQuery = query) }
        // TODO: Implement search filtering logic
    }

    private suspend fun deleteCategory(categoryId: String) {
        updateState { it.copy(isLoading = true) }

        try {
            categoryRepo.deleteCategory(categoryId)
            emitEffect(CategoriesContract.Effect.ShowSuccess("Categorie verwijderd"))
            loadCategories()
        } catch (e: Exception) {
            updateState { it.copy(isLoading = false) }
            emitEffect(CategoriesContract.Effect.ShowError(e.message ?: "Fout bij het verwijderen van categorie"))
        } finally {
            updateState { it.copy(categoryToDelete = null) }
        }
    }
}

